/**************************************************
 * Nombre:       Sostenibilidad_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import hoja from "../../../Recursos/hoja.svg";
import logo from "../../../Recursos/logo_rojo.svg";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {irAtras} from "../../../Utilidades/irAtras";
import {ArrowBackIos} from "@mui/icons-material";

const Sostenibilidad_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 18}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 40, fontWeight: 800, color: theme.palette.primary.main}}>
                                        <span><img src={hoja} width={40} height={'auto'}
                                                   style={{marginTop: 8, marginBottom: -8, paddingRight: 6}}/></span>
                                        Sostenibilidad
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography>
                                        Receptour implementará sus programas según el Calendario Ambiental, con
                                        actividades dirigidas a funcionarios, comunidad y redes sociales. Cada acción
                                        tendrá evidencia registrada y se enviará un cronograma mensual a Zulena Quimbay
                                        para su revisión y aprobación de recursos.
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        {!sCell &&
                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                            <img src={logo} width={'70%'} height={'auto'}/>
                        </Grid>
                        }

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Sostenibilidad_Portada